import React from "react"
import autobind from "class-autobind"
import AppStateStore from "../../../stores/AppStateStore"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import { IJobFilter, ISelectedFilterTemplateId, EDefaultFilterValues } from "../../../models"
import FilterTemplate from "../FilterTemplate"
import AddJobsFilterTemplateDialogContainer from "./AddJobsFilterTemplateDialogContainer"
import strings from "../../../localization/strings"
import * as api from "../../../api"
import * as utils from "../../../helpers/utils"

interface IProps {
    isClientJob?: boolean
    filterTemplates: IJobFilter[]
    selectedFilterTemplateId: ISelectedFilterTemplateId
    handleChangeFilterTemplates(filterTemplates: IJobFilter[]): void
    handleSelectFilterTemlate(selectedFilterTemplateId: ISelectedFilterTemplateId): void
}
interface IState {
}

export default class JobFilter extends React.Component<IProps, IState> {
    private AddJobsFilterTemplateDialogContainer
    constructor(props: IProps) {
        super(props)
        this.state = {
        }
        autobind(this)
    }

    async handleAddFilter(name: string) {
        const filter: IJobFilter = this.AddJobsFilterTemplateDialogContainer.state.filterData
        filter.Id = utils.guid()
        filter.Name = name
        this.props.handleChangeFilterTemplates([...this.props.filterTemplates, filter])
        AppStateStore.setProgressSnackbarContent("loading")
        this.props.isClientJob ?
            await api.addClientJobFilter(AuthenticationStore.getLoggedInUser().Id, filter) :
            await api.addJobFilter(AuthenticationStore.getLoggedInUser().Id, filter)
        this.props.handleSelectFilterTemlate(filter.Id)
        AppStateStore.setProgressSnackbarContent(strings.Filter_Saved)
    }

    async handleUpdateFilter(name: string) {
        const filter: IJobFilter = this.AddJobsFilterTemplateDialogContainer.state.filterData
        filter.Name = name
        this.props.handleChangeFilterTemplates(this.props.filterTemplates.map(i => i.Id === filter.Id ? filter : i))
        AppStateStore.setProgressSnackbarContent("loading")
        this.props.isClientJob ?
            await api.updateClientJobFilter(AuthenticationStore.getLoggedInUser().Id, filter) :
            await api.updateJobFilter(AuthenticationStore.getLoggedInUser().Id, filter)
        this.props.handleSelectFilterTemlate(filter.Id)
        AppStateStore.setProgressSnackbarContent(strings.Filter_Updated)
    }

    async handleDeleteFilter(filterId: string) {
        this.props.handleChangeFilterTemplates(this.props.filterTemplates.filter(i => i.Id !== filterId))
        AppStateStore.setProgressSnackbarContent("loading")
        this.props.isClientJob ?
            await api.deleteClientJobFilter(AuthenticationStore.getLoggedInUser().Id, filterId) :
            await api.deleteJobFilter(AuthenticationStore.getLoggedInUser().Id, filterId)
        this.props.handleSelectFilterTemlate(EDefaultFilterValues.NONE)
        AppStateStore.setProgressSnackbarContent(strings.Filter_Deleted)
    }

    render() {
        const editFilterTemplate = (this.props.selectedFilterTemplateId === EDefaultFilterValues.CREATE_NEW || this.props.selectedFilterTemplateId === EDefaultFilterValues.NONE) ?
            null : this.props.filterTemplates.find(i => i.Id === this.props.selectedFilterTemplateId)
        return (
            <FilterTemplate
                addFilterTemplateLabel={strings.Create_New_Job_Filter}
                editFilterTemplateLabel={strings.Edit_Job_Filter}
                filterTemplates={this.props.filterTemplates}
                selectedFilterTemplateId={this.props.selectedFilterTemplateId}
                style={{ marginTop: -15, marginLeft: 25 }}
                handleSelectFilterTemlate={this.props.handleSelectFilterTemlate}
                handleSave={name => editFilterTemplate ? this.handleUpdateFilter(name) : this.handleAddFilter(name)}
                handleDeleteFilterTemplate={this.handleDeleteFilter}
            >
                <AddJobsFilterTemplateDialogContainer
                    ref={item => this.AddJobsFilterTemplateDialogContainer = item}
                    isClientJob={this.props.isClientJob}
                    editFilterTemplate={editFilterTemplate}
                />
            </FilterTemplate>
        )
    }
}
